import React from 'react'
import { useTranslation } from 'react-i18next'

import { ResidentAppIllustration } from '../../components/ResidentAppIllustration'
import Success from '../../components/Success'

export const QuestionSuccess: React.FC = () => {
  const { t } = useTranslation(['common', 'question'])

  return (
    <Success
      illustration={
        <ResidentAppIllustration
          name="house-hearth-eyes"
          alt={t('question:alt.successIllustration')}
          className="-ml-2"
        />
      }
      heading={t('common:thankYou')}
      text={t('question:texts.success')}
    />
  )
}
